import React, { PureComponent } from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { Flex, Icon, Tooltip } from 'shared/ui'

import ListenToKeyboard from 'components/ListenToKeyboard'
import NavItem from 'components/App/DesktopView/shared/Composer/Email/Header/NavItem'

const iconStyle = css`
  margin-left: -4px;
  margin-right: -4px;
  margin-top: 2px;
  color: inherit;
`

const buttonStyle = () => theme => css`
  font-weight: ${theme.fontWeight.medium};
`

class Trigger extends PureComponent {
  render() {
    const { active, className, forwardedRef, onClick } = this.props

    return (
      <Tooltip
        tooltip={`Insert ${app.t('canned_reply_with_article')} [i]`}
        position="top"
        disabled={active}
      >
        <ListenToKeyboard onI={onClick} preventDefault disableForInput />
        <NavItem active={active} className={className} onClick={onClick}>
          <Flex className="grui flex-1-0-auto" ref={forwardedRef}>
            <div>
              <Icon name="flash_on" size="xsmall" css={iconStyle} />
            </div>
            <div className="grui ml-4" css={buttonStyle}>
              Insert {app.t('canned_reply_short')}
            </div>
          </Flex>
        </NavItem>
      </Tooltip>
    )
  }
}

export default styled(Trigger)`
  .Icon {
    line-height: 24px;
  }
`
